import React from 'react';
import AppUtil from 'js/utils/AppUtil';
import clipboardCopy from 'clipboard-copy';

class NewUrlDialogBox extends React.Component {
    constructor(props) {
		super(props);

        this.state = {};
    };

    handleClick(urlToCopy) {
        clipboardCopy(urlToCopy)
          .then(() => {
            alert('URL copied to the clipboard!');
          })
          .catch((err) => {
            console.error('Error copying URL:', err);
          });
    }
    
    render() {
        return (
            <div className='new-url-dialog-box'>
                <img src={AppUtil.processURLForAppContextPath('images/illustration.png')} alt='web'/>
                <p>Your current link is deprecated. <a href={this.props.url} rel="noopener noreferrer">Click here</a> to continue. </p>
                <div className='new-url-copy'>
                    <span>For direct access in the future, make sure to copy</span>
                    <span className="icon-copy-icon" onClick={() => this.handleClick(this.props.url)}></span>
                    <span>and use the new link.</span>
                </div>
            </div>
        );
    };
}

export default NewUrlDialogBox;